angular
	.module 'App.Repository'
	.factory 'LayoutFolderRepository', ['BaseRepository', (BaseRepository) ->
		class LayoutFolderRepository extends BaseRepository
			@resource = '/layout_folders'
			@isRestricted = true

		return new LayoutFolderRepository
	]
